var adjacent = require('./helper/adjacent');

module.exports = function succ(str) {
  return adjacent(str, -1);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/pred.js
// module id = 813
// module chunks = 0